import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Innovacrystarentinbelgaum() {



    const cardData = {




keyword: "Innova Crysta Rent in Belgaum",

headingDescription: "Belgaum Taxi Service offers premium Innova Crysta rental in Belgaum for family vacations, corporate travel, airport transfers, weddings, business meetings, railway station transfers, sightseeing tours, and outstation journeys. The Toyota Innova Crysta is one of the most preferred premium MPVs for its spacious interiors, superior comfort, ample luggage space, and smooth performance, making it an excellent choice for long-distance as well as local travel. Whether you need an Innova Crysta on rent for a one-way trip, round-trip journey, full-day rental, or multi-day tour, we provide clean, well-maintained vehicles driven by experienced chauffeurs. Our service includes doorstep pickup, transparent pricing, flexible booking options, punctual service, and 24/7 customer support to ensure a comfortable travel experience. Belgaum Taxi Service provides Innova Crysta rentals for destinations across Karnataka, Goa, Maharashtra, and nearby states, making every journey safe, convenient, and enjoyable for families, corporate teams, and groups. Premium SUVs like the Innova Crysta are widely chosen for comfortable outstation travel due to their spacious seating and long-distance comfort.",

topPlaces: [
  {
    title: "Goa",
    description: "Goa is one of the most popular destinations for Innova Crysta rentals from Belgaum, offering beautiful beaches, luxury resorts, churches, water sports, and vibrant nightlife."
  },
  {
    title: "Amboli",
    description: "Amboli is a scenic hill station known for misty valleys, waterfalls, lush greenery, and pleasant weather, making it a favorite destination for comfortable road trips."
  },
  {
    title: "Gokak Falls",
    description: "Gokak Falls is one of Karnataka's most spectacular waterfalls, attracting visitors with its natural beauty, hanging bridge, and picturesque surroundings."
  },
  {
    title: "Kittur",
    description: "Kittur is a historic town famous for Kittur Fort and the legacy of Rani Chennamma. It is a popular destination for heritage and educational tours."
  },
  {
    title: "Bhimgad Wildlife Sanctuary",
    description: "Bhimgad Wildlife Sanctuary is known for dense forests, wildlife, trekking opportunities, and rich biodiversity, making it ideal for nature lovers."
  },
  {
    title: "Sawantwadi",
    description: "Sawantwadi is a charming town in Maharashtra famous for its wooden handicrafts, royal palace, lakes, and traditional art forms."
  },
  {
    title: "Karwar",
    description: "Karwar is a beautiful coastal city renowned for clean beaches, sea views, temples, and peaceful surroundings, making it a popular family getaway."
  },
  {
    title: "Badami",
    description: "Badami is famous for its ancient rock-cut cave temples, sandstone cliffs, Agastya Lake, and remarkable Chalukyan architecture."
  },
  {
    title: "Pattadakal",
    description: "Pattadakal is a UNESCO World Heritage Site celebrated for its magnificent temples and historic architecture, attracting visitors from across India."
  },
  {
    title: "Hampi",
    description: "Hampi is a UNESCO World Heritage destination known for ancient ruins, temples, boulder landscapes, and rich cultural heritage, making it an ideal long-distance road trip from Belgaum."
  }
],




"services": [
  {
    "name": "Innova Crysta Rent in Belgaum",
    "description": "Book Innova Crysta Rent in Belgaum for premium outstation travel, airport transfers, family trips, corporate travel, and chauffeur-driven comfort with spacious seating."
  },
  {
    "name": "Innova Crysta on Rent in Belgaum",
    "description": "Hire Innova Crysta on Rent in Belgaum with experienced drivers, clean AC vehicles, transparent pricing, and reliable service for local and outstation travel."
  },
  {
    "name": "Innova Crysta Rental Belgaum",
    "description": "Choose Innova Crysta Rental Belgaum for luxury travel, business meetings, sightseeing, airport pickup, and comfortable long-distance journeys."
  },
  {
    "name": "Toyota Innova Crysta Hire Belgaum",
    "description": "Reserve Toyota Innova Crysta Hire Belgaum with professional chauffeurs, premium interiors, spacious luggage space, and flexible booking options."
  },
  {
    "name": "Innova Crysta Cab Service Belgaum",
    "description": "Book Innova Crysta Cab Service Belgaum for airport transfers, outstation trips, corporate travel, weddings, and family vacations."
  },
  {
    "name": "Innova Crysta Taxi Belgaum",
    "description": "Travel with Innova Crysta Taxi Belgaum offering fixed fares, clean vehicles, professional drivers, and comfortable highway travel."
  },
  {
    "name": "Innova Crysta Booking Belgaum",
    "description": "Complete Innova Crysta Booking Belgaum with instant confirmation, multiple trip options, and 24x7 customer support."
  },
  {
    "name": "Online Innova Crysta Booking Belgaum",
    "description": "Book Online Innova Crysta Booking Belgaum with secure reservations, quick confirmation, and reliable chauffeur-driven service."
  },
  {
    "name": "Luxury Innova Crysta Rental Belgaum",
    "description": "Choose Luxury Innova Crysta Rental Belgaum for executive travel, VIP transportation, family holidays, and premium road trips."
  },
  {
    "name": "Innova Crysta Car Hire Belgaum",
    "description": "Hire Innova Crysta Car Hire Belgaum with flexible packages for business travel, airport transfers, weddings, and outstation tours."
  },
  {
    "name": "Innova Crysta for Outstation Belgaum",
    "description": "Book Innova Crysta for Outstation Belgaum with fixed pricing, experienced drivers, and comfortable intercity travel."
  },
  {
    "name": "Innova Crysta Airport Transfer Belgaum",
    "description": "Reserve Innova Crysta Airport Transfer Belgaum with on-time pickup, flight tracking, luggage assistance, and premium comfort."
  },
  {
    "name": "Innova Crysta Airport Pickup Belgaum",
    "description": "Book Innova Crysta Airport Pickup Belgaum with punctual chauffeur service, spacious luggage capacity, and reliable transportation."
  },
  {
    "name": "Innova Crysta Airport Drop Belgaum",
    "description": "Choose Innova Crysta Airport Drop Belgaum for timely airport transfers, comfortable seating, and professional drivers."
  },
  {
    "name": "Innova Crysta One Way Cab Belgaum",
    "description": "Book Innova Crysta One Way Cab Belgaum with affordable fares, direct travel, and comfortable chauffeur-driven transportation."
  },
  {
    "name": "Innova Crysta Round Trip Belgaum",
    "description": "Reserve Innova Crysta Round Trip Belgaum with flexible return schedules, premium comfort, and transparent pricing."
  },
  {
    "name": "Innova Crysta Tour Package Belgaum",
    "description": "Choose Innova Crysta Tour Package Belgaum for sightseeing, holiday trips, family vacations, and customized travel itineraries."
  },
  {
    "name": "Premium Innova Crysta Rental Belgaum",
    "description": "Book Premium Innova Crysta Rental Belgaum for luxury travel with experienced chauffeurs, modern amenities, and spacious seating."
  },
  {
    "name": "Corporate Innova Crysta Belgaum",
    "description": "Hire Corporate Innova Crysta Belgaum for executive meetings, airport transfers, client visits, and official business travel."
  },
  {
    "name": "Wedding Innova Crysta Rental Belgaum",
    "description": "Reserve Wedding Innova Crysta Rental Belgaum for bridal transportation, guest travel, family functions, and premium event travel."
  },
  {
    "name": "Family Innova Crysta Cab Belgaum",
    "description": "Book Family Innova Crysta Cab Belgaum for comfortable vacations, pilgrimage tours, airport transfers, and group travel."
  },
  {
    "name": "Luxury Car Rental Belgaum",
    "description": "Choose Luxury Car Rental Belgaum with premium chauffeur-driven vehicles for weddings, business travel, airport transfers, and special occasions."
  },
  {
    "name": "Best Innova Crysta Rental Belgaum",
    "description": "Hire the Best Innova Crysta Rental Belgaum with reliable service, fixed pricing, luxury comfort, and professional chauffeurs."
  },
  {
    "name": "Affordable Innova Crysta Belgaum",
    "description": "Book Affordable Innova Crysta Belgaum with competitive pricing, premium vehicles, and dependable outstation travel."
  },
  {
    "name": "Innova Crysta Hire Near Me Belgaum",
    "description": "Find Innova Crysta Hire Near Me Belgaum with instant booking, nearby pickup, and professional chauffeur service."
  },
  {
    "name": "Innova Crysta Taxi Service in Belgaum",
    "description": "Reserve Innova Crysta Taxi Service in Belgaum for airport transfers, local rides, corporate travel, and outstation journeys."
  },
  {
    "name": "Belgaum to Goa Innova Crysta",
    "description": "Book Belgaum to Goa Innova Crysta with premium comfort, fixed fares, experienced drivers, and smooth intercity travel."
  },
  {
    "name": "Belgaum to Pune Innova Crysta",
    "description": "Travel with Belgaum to Pune Innova Crysta offering spacious seating, AC comfort, transparent pricing, and professional chauffeurs."
  },
  {
    "name": "Belgaum to Mumbai Innova Crysta",
    "description": "Reserve Belgaum to Mumbai Innova Crysta for luxury long-distance travel with comfortable seating and reliable service."
  },
  {
    "name": "Belgaum to Bangalore Innova Crysta",
    "description": "Book Belgaum to Bangalore Innova Crysta with chauffeur-driven luxury vehicles for business and family travel."
  },
  {
    "name": "Belgaum to Hyderabad Innova Crysta",
    "description": "Choose Belgaum to Hyderabad Innova Crysta for premium outstation travel with safe driving and spacious interiors."
  },
  {
    "name": "Belgaum to Kolhapur Innova Crysta",
    "description": "Hire Belgaum to Kolhapur Innova Crysta for comfortable family trips, business travel, and airport transfers."
  },
  {
    "name": "Belgaum to Hubli Innova Crysta",
    "description": "Book Belgaum to Hubli Innova Crysta with fixed fares, experienced chauffeurs, and reliable one way or round trip service."
  },
  {
    "name": "Belgaum to Mahabaleshwar Innova Crysta",
    "description": "Reserve Belgaum to Mahabaleshwar Innova Crysta for scenic road trips, family holidays, and luxury outstation travel."
  },
  {
    "name": "Belgaum to Shirdi Innova Crysta",
    "description": "Travel with Belgaum to Shirdi Innova Crysta offering comfortable seating, professional drivers, and hassle-free pilgrimage journeys."
  },
  {
    "name": "Belgaum Outstation Innova Crysta",
    "description": "Book Belgaum Outstation Innova Crysta for one way trips, round trips, corporate travel, airport transfers, and family vacations with premium comfort."
  }
],

"tableData": [
  ["Innova Crysta Rent in Belgaum", "Innova Crysta on Rent in Belgaum"],
  ["Innova Crysta Rental Belgaum", "Toyota Innova Crysta Hire Belgaum"],
  ["Innova Crysta Cab Service Belgaum", "Innova Crysta Taxi Belgaum"],
  ["Innova Crysta Booking Belgaum", "Online Innova Crysta Booking Belgaum"],
  ["Luxury Innova Crysta Rental Belgaum", "Innova Crysta Car Hire Belgaum"],
  ["Innova Crysta for Outstation Belgaum", "Innova Crysta Airport Transfer Belgaum"],
  ["Innova Crysta Airport Pickup Belgaum", "Innova Crysta Airport Drop Belgaum"],
  ["Innova Crysta One Way Cab Belgaum", "Innova Crysta Round Trip Belgaum"],
  ["Innova Crysta Tour Package Belgaum", "Premium Innova Crysta Rental Belgaum"],
  ["Corporate Innova Crysta Belgaum", "Wedding Innova Crysta Rental Belgaum"],
  ["Family Innova Crysta Cab Belgaum", "Luxury Car Rental Belgaum"],
  ["Best Innova Crysta Rental Belgaum", "Affordable Innova Crysta Belgaum"],
  ["Innova Crysta Hire Near Me Belgaum", "Innova Crysta Taxi Service in Belgaum"],
  ["Belgaum to Goa Innova Crysta", "Belgaum to Pune Innova Crysta"],
  ["Belgaum to Mumbai Innova Crysta", "Belgaum to Bangalore Innova Crysta"],
  ["Belgaum to Hyderabad Innova Crysta", "Belgaum to Kolhapur Innova Crysta"],
  ["Belgaum to Hubli Innova Crysta", "Belgaum to Mahabaleshwar Innova Crysta"],
  ["Belgaum to Shirdi Innova Crysta", "Belgaum Outstation Innova Crysta"]
],





whychoose: [
  {
    WhyChooseheading: "Premium Innova Crysta Rent in Belgaum",
    WhyChoosedescription: "Belgaum Taxi Service offers well-maintained Toyota Innova Crysta rentals for local travel, airport transfers, corporate trips, family vacations, and outstation journeys."
  },
  {
    WhyChooseheading: "Spacious & Comfortable 7-Seater",
    WhyChoosedescription: "Travel comfortably with ample legroom, premium interiors, powerful air conditioning, and generous luggage space, making the Innova Crysta ideal for long-distance journeys."
  },
  {
    WhyChooseheading: "Pickup from Any Location in Belgaum",
    WhyChoosedescription: "Enjoy doorstep pickup from Belgaum Airport, Railway Station, hotels, homes, offices, and nearby areas with convenient drop at your destination."
  },
  {
    WhyChooseheading: "Experienced & Professional Drivers",
    WhyChoosedescription: "Our trained chauffeurs ensure safe driving, punctual service, and a comfortable travel experience on every trip."
  },
  {
    WhyChooseheading: "Perfect for Every Travel Requirement",
    WhyChoosedescription: "Hire an Innova Crysta for corporate travel, airport transfers, weddings, family tours, sightseeing, pilgrimages, and outstation trips across Karnataka, Goa, Maharashtra, and Kerala."
  },
  {
    WhyChooseheading: "Affordable Rental Packages",
    WhyChoosedescription: "Choose from flexible one-way, round-trip, daily, and multi-day rental packages with transparent pricing and no hidden charges."
  },
  {
    WhyChooseheading: "Clean & Well-Maintained Vehicles",
    WhyChoosedescription: "Our Innova Crysta vehicles are regularly serviced, sanitized, and inspected to provide a reliable and comfortable travel experience."
  },
  {
    WhyChooseheading: "24/7 Booking Support",
    WhyChoosedescription: "Book your Innova Crysta in Belgaum anytime with quick confirmation and dedicated customer support."
  }
]

};

const faqData = [
  {
    question: "Does Belgaum Taxi Service provide Innova Crysta rent in Belgaum?",
    answer: "Yes, we provide Toyota Innova Crysta rentals for local travel, airport transfers, corporate travel, sightseeing, and outstation trips."
  },
  {
    question: "Can I book an Innova Crysta for outstation travel?",
    answer: "Yes, our Innova Crysta is available for one-way and round-trip journeys to Goa, Bangalore, Pune, Mumbai, Hubli, Kerala, and other destinations."
  },
  {
    question: "How many passengers can the Innova Crysta accommodate?",
    answer: "The Toyota Innova Crysta comfortably accommodates up to 7 passengers along with sufficient luggage space."
  },
  {
    question: "Do you provide airport pickup and drop in Belgaum?",
    answer: "Yes, we provide reliable Innova Crysta airport transfers to and from Belgaum Airport and Railway Station."
  },
  {
    question: "Is the Innova Crysta available for corporate travel?",
    answer: "Yes, our premium Innova Crysta is ideal for executive travel, business meetings, client transfers, and corporate events."
  },
  {
    question: "Can I rent an Innova Crysta for multiple days?",
    answer: "Yes, we offer daily, weekend, and long-duration Innova Crysta rental packages based on your travel requirements."
  },
  {
    question: "Are toll and parking charges included in the rental fare?",
    answer: "Toll charges, parking fees, state taxes, and other applicable charges are generally billed separately unless mentioned in the confirmed quotation."
  },
  {
    question: "Is the Innova Crysta suitable for family vacations?",
    answer: "Yes, the spacious seating, premium comfort, and large luggage capacity make it an excellent choice for family holidays and group travel."
  },
  {
    question: "Is Innova Crysta rental available 24/7?",
    answer: "Yes, our Innova Crysta rental service is available 24 hours a day for local, airport, and outstation travel."
  },
  {
    question: "How can I book an Innova Crysta Rent in Belgaum?",
    answer: "Simply share your pickup location, destination, travel date, passenger details, and trip duration to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Praveen Joshi",
    feedback: "We rented an Innova Crysta for our family trip, and the experience was outstanding. The vehicle was clean, spacious, and the driver was professional throughout the journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Aditi Kulkarni",
    feedback: "The Innova Crysta was perfect for our corporate travel. Comfortable seating, punctual pickup, and excellent service made the entire trip smooth and enjoyable.",
    rating: 5
  }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Cab Service in Belgaum", link: "Cab-Service-in-Belgaum" },
        { place: "/images/keyword/2.jpg", text: "Belgaum Taxi Service", link: "Belgaum-Taxi-Service" },
        { place: "/images/keyword/3.jpg", text: "Belgaum to Goa Cab", link: "Belgaum-to-Goa-Cab" },
        { place: "/images/keyword/4.jpg", text: "Belgaum to Mahabaleshwar Cab", link: "Belgaum-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Belgaum to Kerala Cab Service", link: "Belgaum-to-Kerala-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Goa to Belgaum Cab", link: "Goa-to-Belgaum-Cab" },
        { place: "/images/keyword/7.jpg", text: "Belgaum to Mumbai Cab", link: "Belgaum-to-Mumbai-Cab" },
        { place: "/images/keyword/8.jpg", text: "Belgaum to Bangalore Cab", link: "Belgaum-to-Bangalore-Cab" },
        { place: "/images/keyword/9.jpg", text: "Goa Cab Service", link: "Goa-Cab-Service" },
        { place: "/images/keyword/10.jpg", text: "Taxi Service in Goa", link: "Taxi-Service-in-Goa" },
        { place: "/images/keyword/11.jpg", text: "Cheapest Cab Service in Goa", link: "Cheapest-Cab-Service-in-Goa" },
        { place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Belgaum", link: "Corporate-Cab-Services-in-Belgaum" },
        { place: "/images/keyword/13.jpg", text: "Innova Crysta Rent in Belgaum", link: "Innova-Crysta-Rent-in-Belgaum" },
        { place: "/images/keyword/14.jpg", text: "Ertiga on Rent in Belgaum", link: "Ertiga-on-Rent-in-Belgaum" },
        { place: "/images/keyword/15.jpg", text: "Tempo Traveller Rent in Belgaum", link: "Tempo-Traveller-Rent-in-Belgaum" },
        { place: "/images/keyword/16.jpg", text: "Mini Bus Rental Belgaum", link: "Mini-Bus-Rental-Belgaum" },
        { place: "/images/keyword/17.jpg", text: "Swift Dzire on Rent in Belgaum", link: "Swift-Dzire-on-Rent-in-Belgaum" },
        { place: "/images/keyword/18.jpg", text: "Urbania on Rent in Belgaum", link: "Urbania-on-Rent-in-Belgaum" },
        { place: "/images/keyword/19.jpg", text: "Wedding Car Rental in Belgaum", link: "Wedding-Car-Rental-in-Belgaum" },
        { place: "/images/keyword/20.jpg", text: "Cabs in Belgaum", link: "Cabs-in-Belgaum" },
        { place: "/images/keyword/21.jpg", text: "Belgaum to Hubli Cab", link: "Belgaum-to-Hubli-Cab" },
        { place: "/images/keyword/22.jpg", text: "Belgaum to Dharwad Cab", link: "Belgaum-to-Dharwad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Belgaum to Kolhapur Cab", link: "Belgaum-to-Kolhapur-Cab" },
        { place: "/images/keyword/24.jpg", text: "Belgaum Airport Cab Service", link: "Belgaum-Airport-Cab-Service" },
        { place: "/images/keyword/25.jpg", text: "Belgaum to Bagalkot Cab", link: "Belgaum-to-Bagalkot-Cab" },
    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Innova Crysta Rent in Belgaum",
  "image": "https://www.belgaumtaxiservice.com/assets/images/innova-crysta-rent-in-belgaum.webp",
  "description":
    "Book Innova Crysta Rent in Belgaum with Belgaum Taxi Service for premium and comfortable taxi services. We provide Toyota Innova Crysta rentals for outstation trips, airport transfers, family travel, corporate journeys, and special occasions with professional drivers available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Belgaum Taxi Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.belgaumtaxiservice.com/innova-crysta-rent-in-belgaum"
  }
};




    return (
        <div>


<Helmet>
  <title>Innova Crysta Rent in Belgaum | Luxury Cab Booking | +91 8722158435</title>

  <meta
    name="description"
    content="Book Innova Crysta Rent in Belgaum with Belgaum Taxi Service for premium taxi rental services. Hire Toyota Innova Crysta for outstation trips, airport transfers, family travel, corporate journeys, and special occasions with professional drivers available 24x7."
  />

  <meta
    name="keywords"
    content="Innova Crysta Rent in Belgaum, Innova Crysta on Rent in Belgaum, Innova Crysta Rental Belgaum, Toyota Innova Crysta Hire Belgaum, Innova Crysta Cab Service Belgaum, Innova Crysta Taxi Belgaum, Innova Crysta Booking Belgaum, Online Innova Crysta Booking Belgaum, Innova Crysta Car Rental Belgaum, Innova Crysta Outstation Cab Belgaum"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>







            <div className="page-headder bg-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="page-header-box text-white">
                                <h1 className="text-anime-style-3 text-center text-white">
                                    {cardData.keyword}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/13.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Belgaum Taxi Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Belgaum Taxi Service</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Belgaum Taxi Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918722158435 " className="pc-call">+91 8722158435 </a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918722158435 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918722158435 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@belgaumtaxiservice.com" className="pc-email">
                                            booking@belgaumtaxiservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Belgaum Taxi Service</strong><br />
                                            P No 30 cCTS No 7023,
                                            Sector No 9 Malmaruti Anjaneya Nagar,
                                            Belgaum, Karnataka - 590017




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Innovacrystarentinbelgaum;